module.exports = __webpack_public_path__ + "img/inactiveicon-hierarchy.0761d871.svg";